function state () {
	return {
		features: [],
		total: 0
	}
}

export default state
